import React from "react";
import Error from '@material-ui/icons/Error';
import styles from "./PciWarning.module.scss";

const PciWarning = () => {
  return (
    <div className={styles.warning}>
      <div className={styles.warningIcon}>
        <Error className={styles.icon} />
      </div>
      <div className={styles.warningCopy}>
        <p>
          In accordance with{' '}
          <a href="https://www.pcisecuritystandards.org/" target="_blank">PCI Data Security Standards</a>, please do
          not include credit/debit card details within documents uploaded to this form.
        </p>
      </div>
    </div>
  )
};

export default PciWarning;

